import React from "react"
import styled, { CSSProp, css } from "styled-components"

import { ThemeProps } from "src/legacy/theme"
import { ElementProps, elementCss } from "legacy/components/shared/base"

export type InputVariant = "inline" | "primary" | "block" | "mobile"

interface OwnProps {
  error?: boolean
  theme: ThemeProps
  variant?: InputVariant
}

export type StyledInputProps = React.InputHTMLAttributes<HTMLInputElement> &
  ElementProps &
  OwnProps

function autoFillButtonStyles(): CSSProp {
  return css`
    &::-webkit-contacts-auto-fill-button {
      position: absolute;
      right: 2px;
    }
  `
}

function borderStyles(props: StyledInputProps): CSSProp {
  if (
    props.variant === "inline" ||
    props.variant === "block" ||
    props.variant === "mobile"
  ) {
    const border = props.border || "none"

    return css`
      border: ${border};
    `
  }

  return css`
    border: none;

    &:focus {
      border: none;
    }
  `
}

function paddingStyles(props: StyledInputProps): CSSProp {
  switch (props.variant) {
    case "inline":
      return css`
        padding-left: ${props.theme.space.input.gutterXInline};
        padding-right: ${props.theme.space.input.gutterXInline};
      `
    case "block":
      return css`
        padding-left: ${props.theme.space.input.gutterXInline};
        padding-right: ${props.theme.space.input.gutterXInline};
      `
    case "mobile":
      return css`
        padding-left: ${props.theme.space.input.gutterXInline};
        padding-right: ${props.theme.space.input.gutterXInline};
      `
    default:
      return css`
        padding-left: ${props.theme.space.input.gutterX};
        padding-right: ${props.theme.space.input.gutterX};
      `
  }
}

function placeholderStyles(props: StyledInputProps): CSSProp {
  return css`
    &::placeholder {
      color: ${props.theme.colors.placeholder};
    }
  `
}

function variantStyles(props: StyledInputProps): CSSProp {
  const variant = props.variant || "primary"
  return css`
    border-bottom-left-radius: ${props.theme.radii.input[variant]};
    border-bottom-right-radius: ${variant === "inline"
      ? "0"
      : props.theme.radii.input[variant]};
    border-top-left-radius: ${props.theme.radii.input[variant]};
    border-top-right-radius: ${variant === "inline"
      ? "0"
      : props.theme.radii.input[variant]};
  `
}

const StyledInput = styled.input<StyledInputProps>`
  outline: none;
  ${elementCss};
  ${autoFillButtonStyles}
  ${borderStyles}
  ${paddingStyles}
  ${placeholderStyles}
  ${variantStyles}
`

StyledInput.defaultProps = {
  boxShadow: "none",
  fontFamily: "martel",
  height: "100%",
  lineHeight: "3",
  m: "0 auto",
  pt: "lineHeightOffset",
  position: "relative",
  width: "100%",
}

export default StyledInput
